import type { Theme } from '@mui/material';
import type { CSSObject } from 'styled-components';
import { makeStyles } from 'tss-react/mui';

export const generateAutocompleteCss = (theme: Theme): CSSObject => {
  return {
    '&.MuiAutocomplete-root': {
      height: 'fit-content',

      '&.disabled': {
        opacity: '0.5',
      },

      input: {
        paddingLeft: '8px !important',
      },

      '.MuiAutocomplete-endAdornment': {
        svg: {
          fontSize: '1.5rem',
          fill: theme.new.color.textSecondary,
        },
      },
    },
  };
};

const useStyles = makeStyles()((theme) => ({
  option: {
    height: '48px',
    padding: '8px 24px',

    '&[aria-selected="true"]': {
      background: theme.new.color.grey[100],
    },

    '&:hover': {
      background: theme.new.color.brand[100],
      color: theme.new.color.brand[600],
    },

    '&.Mui-focused': {
      background: theme.new.color.brand[100],
      color: theme.new.color.brand[600],
    },
  },
}));

export default useStyles;
